<article class="draggable-action card">
  <section class="selection">
    <ng-container *ngIf="selectable">
      <div class="custom-control custom-checkbox">
        <input [(ngModel)]="selected"
               [id]="checkboxId"
               class="custom-control-input"
               type="checkbox">
        <label [for]="checkboxId"
               class="custom-control-label"></label>
      </div>
    </ng-container>
  </section>

  <div (click)="clicked.emit([model, $event])"
       class="grouping">
    <section class="action-type">
      <app-action-icon [icon]="model.type"
                       variant="thick"></app-action-icon>
      <h6>{{ localisableActionType | translate }}</h6>
    </section>
    <section (click)="toggleMenu($event)"
             [class.with-menu]="customStatusView.children.length"
             [ngClass]="textClassForStatus"
             class="status">
      <div [matMenuTriggerFor]="jobActions.menu"></div>
      <span #customStatusView><ng-content select="[statusView]"></ng-content></span>
      <span *ngIf="!customStatusView.hasChildNodes()">
        {{ model.status | translateEnum: "actionStatusType" }}
        </span>
    </section>
    <section class="subtitle">
      <ng-container *ngIf="shouldShowBuilding">
        <i class="fas fa-map-marker"></i>
        {{ model.issues[0].issueBuildingLabel }}
      </ng-container>
      <ng-container *ngIf="shouldShowLocation">
        <i class="fas fa-map-marker"></i>
        {{ fullLocationLabel }}
      </ng-container>
      <ng-container *ngIf="shouldShowTeam">
        <i class="fas fa-users"></i>
        {{ model.interventionTeam?.label }}
      </ng-container>
    </section>
    <section class="date">
      <ng-container *ngIf="model.dueDate">
        <i class="fa fa-calendar"></i>
        {{ model.dueDate | date: config.DATE_FORMAT }}
      </ng-container>
    </section>
  </div>
</article>
<app-action-contextual-menu #jobActions
                            (assign)="assign.emit([model, $event])"
                            (delete)="delete.emit(model)"
                            [teams]="teams"></app-action-contextual-menu>
